import { render, staticRenderFns } from "./DropdownFilter.vue?vue&type=template&id=894ab310&scoped=true&"
import script from "./DropdownFilter.vue?vue&type=script&lang=js&"
export * from "./DropdownFilter.vue?vue&type=script&lang=js&"
import style0 from "./DropdownFilter.vue?vue&type=style&index=0&id=894ab310&prod&lang=scss&scoped=true&"
import style1 from "./DropdownFilter.vue?vue&type=style&index=1&id=894ab310&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894ab310",
  null
  
)

export default component.exports